import React, { useState } from 'react'
import PageHeader from '../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../Component/BasicComponents/BasicDataTable';
import { useUserSession } from './hooks/useEmployee';
import { useLocation } from 'react-router-dom';

type Props = {}

const UserSession = (props: Props) => {
    const location=useLocation();
    const UserId=location?.state?.UserId;
    console.log('userId',UserId)
    
      const [filtersState, setFiltersState] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
      });
 const SessionListColumns = () => [
    {
      name: "SessionId",
      selector: (row: { SessionId: number | string }) =>
        row.SessionId || "-",
      sortable: true,
      width:'130px'
    
      
    },
    {
      name: "UserId",
      selector: (row: { UserId: string }) => row.UserId || "-",
      sortable: true,
    },
    {
      name: "Device Name",
      selector: (row: { DeviceName: string }) => row?.DeviceName || "-", // (depend by backend)
      sortable: true,
    },
    {
      name: "Device Version",
      selector: (row: { DeviceVersion: string }) => row?.DeviceVersion || "-", // (depend by backend)
      sortable: true,
    },
    {
      name: "IpAddress",
      selector: (row: { IpAddress: string }) => row?.IpAddress || "-",
      sortable: true,
    },
    {
      name: "CreatedAt",
      selector: (row: { CreatedAt: string }) => row?.CreatedAt || "-",
      sortable: true,
    },
   
  ];

  const { data: UserSessionData,isLoading } = useUserSession({
    enabled: true,
    empId: UserId,
    params: {
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
    },
  })

   const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  return (
    <>
    <PageHeader
        title="User Session"
      />
      <BasicDataTable
      showSpinner={isLoading}
        paginationTotalRows={UserSessionData?.data?.Pagination?.TotalUserSessions||0}
       onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="User Session"
        columns={SessionListColumns()}
        data={UserSessionData?.data?.UserSession|| []}
        
      />
      </>
  )
}
export default UserSession;